export default __webpack_public_path__ + "static/media/Duck Hunting 2.16b40d57.jpg";